import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import { Button } from "@mui/material";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { useEffect, useMemo, useRef, useState } from "react";
import { useNavigate } from "react-router";
import GetODS from "../../data/GetODS";
import { useProyecto } from "../../data/ProyectoContext";
import { useAuthContext } from "../../hooks/Auth";
import { useJobContext } from "../../hooks/Jobs";
import DuracionHorasSemana from "../Duracion/DuracionHorasSemana";
import DuracionSemanas from "../Duracion/DuracionSemanas";
import { useActividadesContext } from "../UmmIACategories/Hook/useActividades";
import HeaderApps from "../UmmIACategories/Layout/HeaderApps";
import UnidadTematicaCardImg from "../UmmIApps/Cards/ClaseActivaCardImg.png";
import NameHelp from "../Form/Indications/NameHelp";
import { Ods } from "../../interfaces/Proyecto/iProyecto";
import { FormattedAsignatura } from "../../interfaces/ObjetivosAprendizaje/iAsignaturas";
import NotEnoughCredits from "../UmmIApps/NotEnoughCredits";
import ProjectName from "../Form/Fields/Nombre";
import Problematica from "../Form/Fields/Problematica";
import Contexto from "../Form/Fields/Contexto";
import AdaptacionesCurricularesABP from "../Form/Fields/AdaptacionesCurricularesABP";
import HabilidadesSocioemocionales from "../Form/Fields/HabilidadesSocioemocionales";
import CompetenciasSigloXXI from "../Form/Fields/CompetenciasSigloXXI";
import CurriculumTabsABP from "../CurriculumTabs/CurriculumTabsABP/CurriculumTabsABP";
import { FormattedNivelTP } from "../../data/GetNivelesTP";
import { isSendButtonDisabled } from "../../config/sendButtonRules";

// **** ETAPA = 0 ****

export default function NuevoABP({
  onNextStep,
}: {
  onNextStep: () => void;
}) {
  const [openNameTypeHelp, setOpenNameTypeHelp] = useState(false);
  const [expanded, setExpanded] = useState(false);
  const ref = useRef<HTMLElement | null>(null);
  const { proyecto, enviarPropuestaInicialUsuarioBeta, setProyecto } =
    useProyecto();
  const [mostrarCamposAvanzados, setMostrarCamposAvanzados] = useState(false);

  const [selectedAsignatura, setSelectedAsignatura] =
    useState<FormattedAsignatura | null>(null);

  //Funciones para mostrar los campos avanzados
  const toggleCamposAvanzados = () => {
    setMostrarCamposAvanzados(!mostrarCamposAvanzados);
  };

  // Funciones para manejar la apertura y cierre de los modales de ayuda
  const handleOpen = () => setOpenNameTypeHelp(true);
  const handleClose = () => setOpenNameTypeHelp(false);

  //Condicionamiento para botón
  const isButtonDisabled = isSendButtonDisabled("abp_beta", { proyecto });

  const { isCompleted, wsProject, etapa, tipoEstructura, userId } =
    useJobContext();

  const { user } = useAuthContext();

  const {
    nivelId,
    setNivelId,
    objetivosSeleccionados,
    promptData,
    setObjetivosSeleccionados,
    setPromptData,
    setIsOAAdded,
    isOAAdded,
    setIsPersist,
    handleNivelChangeABP,
    setPersistenciaHabilitada,
    handleAsignaturaChangeLocalABP,
    setIsNotEnoughOpen,
    selectedApp
  } = useActividadesContext();

  useEffect(() => {
    //  Desactiva persistencia antes de cualquier render
    setPersistenciaHabilitada(false);
    setIsPersist(false);

    // Limpia estados relacionados con selección
    setPromptData({});
    setNivelId(null);
    setObjetivosSeleccionados({});
    setProyecto((prev) => ({
      ...prev,
      nivel_curso: "",
      materias: [],
      objetivos_aprendizaje: [],
    }));
    setIsOAAdded(false);
  }, []); //  Solo se ejecuta al montar FormProyect

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        expanded &&
        ref.current &&
        !ref.current.contains(event.target as Node)
      ) {
        setExpanded(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [expanded]);

  const handleODSChange = (ods: Ods) => {
    // Verifica si el ODS tiene un nombre válido
    if (ods && ods.nombre) {
      // Verifica si el ODS ya está presente en el array del estado del proyecto
      if (!proyecto.ods.some((selectedODS) => selectedODS.id === ods.id)) {
        // Agrega el objeto ODS al array en el estado del proyecto
        setProyecto((prevProyecto) => ({
          ...prevProyecto,
          ods: [...prevProyecto.ods, { id: ods.id, nombre: ods.nombre }],
        }));
      }
    }
  };

  //Escuchamos los eventos emitidos desde el servidor y esperamos la respuesta
  useEffect(() => {
    const resp = () => {
      if (
        wsProject &&
        Object.keys(wsProject).length != 0 &&
        etapa === 0 &&
        isCompleted
      ) {
        onNextStep();
      }
    };
    resp();
  }, [wsProject, etapa, isCompleted]);

  //Manejando el envío de la prouesta seleccionada del usuario al servidor
  const handleSendInfo = async () => {
    if (!user || !selectedApp) return;

    const ummiappId = selectedApp.id_componente;
    const ummiappName = selectedApp.nombre;

    const { usuario, ...restoProyecto } = proyecto;
    const { roles, categories, ummiapps, ...usuarioSinCampos } = user || {};

    const proyectoActualizado = {
      ...restoProyecto,
      usuario: usuarioSinCampos,
      ummiappId,
      ummiappName,
    };

    console.log("Proyecto actualizado:", proyectoActualizado);
    window.scrollTo({ top: 0, behavior: "smooth" });

    if (user.creditosDisponibles < selectedApp.valor_creditos) {
      setIsNotEnoughOpen(true);
    } else {
      // Enviar con los datos actualizados
      enviarPropuestaInicialUsuarioBeta(proyectoActualizado, "crear_proyecto");
    }
  };



  const navigate = useNavigate();
  const handleBack = () => {
    navigate("/asistente/ummiaplan");
  };


  type SimpleIdNombre = { id: string; nombre: string };
  const EMPTY_SIMPLE: SimpleIdNombre = { id: "", nombre: "" };

  const [nivelTP, setNivelTP] = useState<FormattedNivelTP | null>(null);
  const [asignaturaTP, setAsignaturaTP] = useState<SimpleIdNombre>(EMPTY_SIMPLE);


  const getNivelTPId = (nivel: FormattedNivelTP | null): string => {
    if (!nivel) return "";
    const anyNivel = nivel as any;
    return String(anyNivel.id ?? anyNivel.id_nivel ?? anyNivel.idNivel ?? "");
  };

  const nivelTPId = useMemo(() => getNivelTPId(nivelTP), [nivelTP]);
  const asignaturaTPId = asignaturaTP.id;

  const handleNivelTPChange = (nivel: FormattedNivelTP) => {
    setNivelTP(nivel);

    setProyecto((prev: any) => ({
      ...prev,
      nivel_curso: (nivel as any)?.nombre ?? "",
    }));


    setPromptData((prev: any) => ({
      ...prev,
      nivel: (nivel as any)?.nombre ?? "",
    }));

    // Cuando cambia el nivel, se suele limpiar la asignatura
    setAsignaturaTP(EMPTY_SIMPLE);
  };

  const handleAsignaturaTPChangeLocal = (a: { id: string; nombre: string }) => {
    const next = { id: String(a?.id ?? ""), nombre: String(a?.nombre ?? "") };
    setAsignaturaTP(next);
  };

  const clearTP = () => {
    setNivelTP(null);
    setAsignaturaTP(EMPTY_SIMPLE);

    // Limpieza mínima para no dejar el botón habilitado con datos viejos
    setProyecto((prev: any) => ({
      ...prev,
      nivel_curso: "",
      materias: [],
      objetivos_aprendizaje: Array.isArray(prev?.objetivos_aprendizaje) ? [] : prev?.objetivos_aprendizaje,
    }));

    setPromptData((prev: any) => ({
      ...prev,
      nivel: "",
      materia: "",
    }));


    setIsOAAdded(false);
  };




  return (
    <>
      <HeaderApps
        imageSrc={UnidadTematicaCardImg}
        backgroundColorImage={
          "linear-gradient(180deg, #FFFFFF 0%, #A9D1C0 100%, #52A381 100%)"
        }
        titleColor="#278C62"
        title="Planificación ABP PRUEBA"
        description="Diseña proyectos de Aprendizaje Basado en Problemas (ABP) de manera
        eficiente con UmmIA."
        onBack={handleBack}
        colorIconBack={"#52A381"}
      />
      {/*Formulario*/}
      {/*Contenedor principal del formulario */}{" "}
      <Grid container>
        {/*Contenedor para objetivos */}
        <Grid item xs={12}>
          <CurriculumTabsABP
            // CN/ABP
            nivelId={nivelId}
            handleNivelChangeABP={handleNivelChangeABP}
            selectedAsignatura={selectedAsignatura}
            setSelectedAsignatura={setSelectedAsignatura}
            handleAsignaturaChangeLocalABP={handleAsignaturaChangeLocalABP}
            objetivosSeleccionados={objetivosSeleccionados}
            setObjetivosSeleccionados={setObjetivosSeleccionados}
            setIsOAAdded={setIsOAAdded}

            // prompt
            promptData={promptData}
            setPromptData={setPromptData}

            // TP (conecta desde context o usa placeholders)
            nivelTPId={nivelTPId}
            asignaturaTPId={asignaturaTPId}
            handleNivelTPChange={handleNivelTPChange}
            handleAsignaturaTPChangeLocal={handleAsignaturaTPChangeLocal}
            clearTP={clearTP}
          />
        </Grid>

        {/*Contenedor para tema del proyecto, duración y tipo de la clase */}
        <>
          <Typography
            sx={{
              fontFamily: "montserrat",
              fontSize: "1.25rem",
              fontWeight: "bold",
              color: "#1D3D4D",
            }}
          >
            Tema y duración de la clase{" "}
            <Button sx={{ color: "#1D3D4D" }} onClick={handleOpen}>
              <HelpOutlineIcon />
            </Button>
          </Typography>
          {/*Modal sección Nombre y tipo de proyecto*/}{" "}
          <NameHelp open={openNameTypeHelp} onClose={handleClose} />
          {/*Campo nombre de proyecto */}
          <ProjectName />
          {/*Campos de duración semanal y horaria */}
          <Grid container spacing={2}>
            {" "}
            <Grid item xs={12} md={6}>
              {" "}
              <DuracionSemanas />
            </Grid>
            <Grid item xs={12} md={6}>
              {" "}
              <DuracionHorasSemana />
            </Grid>
          </Grid>
        </>

        {/*Contenedor para configuraciones de proyecto */}
        <>
          <Grid
            item
            xs={12}
            container
            justifyContent="center"
            sx={{ mb: 3, mt: 5 }}
          >
            <Button
              variant="text"
              sx={{ color: "#336B87", fontFamily: "montserrat" }}
              onClick={toggleCamposAvanzados}
              endIcon={
                mostrarCamposAvanzados ? <ExpandMoreIcon /> : <ExpandMoreIcon />
              }
            >
              {mostrarCamposAvanzados
                ? "Ocultar opciones avanzadas"
                : "Mostrar opciones avanzadas (opcional)"}
            </Button>
          </Grid>

          {/* Campos avanzados */}
          {mostrarCamposAvanzados && (
            <>
              {/*Acordeon para agregar indicaciones y conceptos clave */}{" "}
              <Grid item xs={12}>
                <Problematica />

                <Contexto />

                <AdaptacionesCurricularesABP />

                <HabilidadesSocioemocionales />

                <CompetenciasSigloXXI />
              </Grid>
              {/* Campo de selección para un ODS*/}
              <GetODS onODSChange={handleODSChange} />
            </>
          )}
        </>
      </Grid>
      {/*Botón para enviar la información*/}
      <Button
        variant="contained"
        onClick={handleSendInfo}
        disabled={ isButtonDisabled }
        data-amplify-analytics-on="click"
        data-amplify-analytics-name={`click-on-ummia-proponme-ideas`}
        data-amplify-analytics-attrs={`onClick:handleSendInfo, userId:${userId}, tipoEstructura:${tipoEstructura}, etapa:${etapa}`}
        sx={{
          borderRadius: 5,
          m: "auto",
          width: "60%",
          alignContent: "center",
          backgroundColor: "#1FC16B",
          "&:hover": {
            backgroundColor: "#34C759",
          },
          fontFamily: "montserrat",
          fontWeight: "bold",
        }}
      >
        ¡UMMIA, proponme ideas geniales!
      </Button>
      {/* Popup en caso de que se excedan créditos */}
      <NotEnoughCredits />
    </>
  );
}
